var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SoundQuestion',{attrs:{"role":_vm.role,"ask-question":"Luister goed naar het liedje!","question":"Hoe gaat het liedje verder?","correct-answer":"Maar ik moet naar bedje toe","wrong-answers":['Maar hij moet naar bedje toe',
  'Dus gaat hij naar gertje toe',
  'Maar hij is aan wat haver toe',
  'Dus hij gaat naar bedje toe'
  ,'Dus hij gaat niet naar bedje toe'],"ask-question-audio":require('@/assets/audio/vraag_5_vraag.mp3'),"answer-audio":require('@/assets/audio/vraag_5_antwoord.mp3'),"show-answer-after":9000,"total-seconds":30}})}
var staticRenderFns = []

export { render, staticRenderFns }